import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import ErrorBoundary from './components/ErrorBoundary';

// Use REACT_APP_USE_MOCK=true to enable MirageJS mock server
// By default, use the real backend server
if (process.env.REACT_APP_USE_MOCK === 'true') {
  if (process.env.NODE_ENV !== 'production') {
    console.log('🔧 Using MirageJS mock server');
  }
  // Dynamic import to avoid bundling miragejs in production
  import('./mock/server').then(({ makeServer }) => {
    makeServer({ environment: 'development' });
  });
} else if (process.env.NODE_ENV !== 'production') {
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
  console.log(`🚀 Using real backend server at ${apiUrl}`);
}

// Reload once when a lazy-loaded chunk is missing after a new deploy
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('Loading chunk')) {
    const reloaded = sessionStorage.getItem('chunk_reload');
    if (!reloaded) {
      sessionStorage.setItem('chunk_reload', '1');
      window.location.reload();
    }
  }
});

// NOTE: The push service worker is registered inside Root.tsx once the user is
// authenticated. Registering here (unconditionally on load) would put /login
// under SW control, which has historically caused transient "Failed to fetch"
// errors on the first sign-in request.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <App />
    </Provider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
